var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_5456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3285 1.33203H4.66466C2.8245 1.33203 1.33276 2.82377 1.33276 4.66393V11.3277C1.33276 13.1679 2.8245 14.6596 4.66466 14.6596H11.3285C13.1686 14.6596 14.6603 13.1679 14.6603 11.3277V4.66393C14.6603 2.82377 13.1686 1.33203 11.3285 1.33203Z",
    stroke: "#F6339A",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6621 7.57727C10.7443 8.13186 10.6496 8.69826 10.3914 9.19591C10.1331 9.69356 9.72457 10.0971 9.22377 10.3492C8.72298 10.6013 8.15545 10.689 7.60191 10.5999C7.04838 10.5108 6.53702 10.2495 6.14058 9.85306C5.74413 9.45662 5.48279 8.94526 5.39372 8.39172C5.30465 7.83819 5.39238 7.27066 5.64445 6.76986C5.89652 6.26907 6.30007 5.8605 6.79773 5.60228C7.29538 5.34406 7.86178 5.24933 8.41637 5.33157C8.98207 5.41546 9.5058 5.67906 9.91019 6.08345C10.3146 6.48784 10.5782 7.01156 10.6621 7.57727Z",
    stroke: "#F6339A",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6616 4.33203H11.6683",
    stroke: "#F6339A",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_5456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9931,
    height: 15.9931,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.04e6a7b7e5dc9126313455a21de2bca3.svg";
export { ForwardRef as ReactComponent };